<template>
    <v-container fluid>
        <div class="fu-bar mb-4">
            <v-btn depressed color="primary" class="back-btn" @click="goBack">
                <v-icon small class="me-1">mdi-arrow-right</v-icon>
                <span>{{ $t('Back') }}</span>
            </v-btn>
            <div v-if="generalInfo" class="fu-title">
                <v-icon small color="primary" class="me-2">mdi-file-tree-outline</v-icon>
                <span class="fu-title-txt">{{ generalInfo.processTitle }}</span>
            </div>
        </div>

        <div>
            <GeneralInformation :general-info="generalInfo" />
        </div>
        <div v-if="surveyIdComp !== null" class="mt-4">
            <AddSurvey :isDisabled="true" :surveyIdComp="surveyIdComp"></AddSurvey>
        </div>

        <!-- request views (self-hide for any other process type) -->
        <div class="mt-4">
            <RequestView :process-instance-id="processId" />
        </div>
        <div class="mt-4">
            <InquiryRequestView :process-instance-id="processId" />
        </div>
        <div class="mt-4">
            <StrategicSatisfactionRequestView :process-instance-id="processId" />
        </div>
        <div class="mt-4">
            <OperationalIndicatorRequestView :process-instance-id="processId" />
        </div>
        <div class="mt-4">
            <AdditionalAnalysisRequestView :process-instance-id="processId" />
        </div>
        <div class="mt-4">
            <ScientificConsultationRequestView :process-instance-id="processId" />
        </div>
        <div class="mt-4">
            <FocusGroupsRequestView :process-instance-id="processId" />
        </div>
    </v-container>
</template>

<script>
    import GeneralInformation from '@/components/app/followUp/GeneralInformation.vue'
    import AddSurvey from '@/pages/Admin/Surveys/AddSurvey.vue'
    import RequestView from '@/components/app/task/RequestView.vue'
    import InquiryRequestView from '@/components/app/task/InquiryRequestView.vue'
    import StrategicSatisfactionRequestView from '@/components/app/task/StrategicSatisfactionRequestView.vue'
    import OperationalIndicatorRequestView from '@/components/app/task/OperationalIndicatorRequestView.vue'
    import AdditionalAnalysisRequestView from '@/components/app/task/AdditionalAnalysisRequestView.vue'
    import ScientificConsultationRequestView from '@/components/app/task/ScientificConsultationRequestView.vue'
    import FocusGroupsRequestView from '@/components/app/task/FocusGroupsRequestView.vue'
    import ProcessesService from '@/services/ProcessesService.js'

    export default {
        components: {
            GeneralInformation, AddSurvey, RequestView, InquiryRequestView,
            StrategicSatisfactionRequestView, OperationalIndicatorRequestView, AdditionalAnalysisRequestView,
            ScientificConsultationRequestView, FocusGroupsRequestView
        },

        data() {
            return {
                loading: false,
                generalInfo: null,
                surveyIdComp:null,
                processId: parseInt(this.$route.params.processInstanceId)
            }
        },

        created() {
            this.getProcess()
        },

        methods: {
            goBack() {
                this.$router.push({ name: 'followup' })
            },
            getProcess() {
                this.loading = true
                ProcessesService.getProcess(this.processId)
                    .then((res) => {
                        this.generalInfo = res.data
                        // only SurveyApproval processes embed a survey id in their title; others (e.g. the
                        // survey-execution request) must NOT load AddSurvey with a NaN id
                        const title = this.generalInfo.processTitle || ''
                        const parts = title.split('إجراء الموافقة على الاستبيانات بعنوان ')
                        const surveyId = parts.length > 1 ? Number(parts[1]) : NaN
                        this.surveyIdComp = Number.isInteger(surveyId) ? surveyId : null
                    })
                    .finally(() => {
                        this.loading = false
                    })
            }
        },
    }
</script>

<style scoped>
    .fu-bar {
        display: flex; align-items: center; gap: 16px;
        background: #fff; border: 1px solid #e6ebf0; border-radius: 12px;
        padding: 10px 16px; box-shadow: 0 2px 8px rgba(27,131,84,.05);
    }
    .back-btn { border-radius: 9px; font-weight: 600; }
    .back-btn ::v-deep .v-btn__content { gap: 4px; }
    .fu-title { display: flex; align-items: center; min-width: 0; }
    .fu-title-txt {
        font-weight: 700; font-size: 14px; color: #2f3e4a;
        overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
    }
</style>